// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__Dac5p","layout-container":"style_layout-container__drAe6","item":"style_item___hqiR","arrow":"style_arrow__uCoP8"};